"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useConnectivityStatus;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useConnectivityStatus() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var connectivityStatus = _ref.connectivityStatus;
    return connectivityStatus;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VDb25uZWN0aXZpdHlTdGF0dXMudHMiXSwibmFtZXMiOlsidXNlQ29ubmVjdGl2aXR5U3RhdHVzIiwiY29ubmVjdGl2aXR5U3RhdHVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRWUsU0FBU0EscUJBQVQsR0FBMkM7QUFDeEQsU0FBTyxDQUFDLHNDQUFZO0FBQUEsUUFBR0Msa0JBQUgsUUFBR0Esa0JBQUg7QUFBQSxXQUE0QkEsa0JBQTVCO0FBQUEsR0FBWixDQUFELENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlU2VsZWN0b3IgfSBmcm9tICcuL2ludGVybmFsL1dlYkNoYXRSZWR1eENvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VDb25uZWN0aXZpdHlTdGF0dXMoKTogW3N0cmluZ10ge1xuICByZXR1cm4gW3VzZVNlbGVjdG9yKCh7IGNvbm5lY3Rpdml0eVN0YXR1cyB9KSA9PiBjb25uZWN0aXZpdHlTdGF0dXMpXTtcbn1cbiJdfQ==